import type { ErrorProvider } from "@/lib/errors/types";

export class NullErrorProvider implements ErrorProvider {
  async captureException(): Promise<void> {}
  async captureMessage(): Promise<void> {}
  async setUser(): Promise<void> {}
  async captureLog(): Promise<void> {}
  async flush(): Promise<void> {}
}

export const nullErrorProvider = new NullErrorProvider();
